type FontProps = {
  [key: string]: string;
};

const FONT: FontProps = {
  primary: 'Montserrat',
};

export default FONT;
